// extracted by mini-css-extract-plugin
module.exports = {"loadingMochi":"loading-card_loadingMochi__2Ajqc","placeHolderShimmer":"loading-card_placeHolderShimmer__m9rnt"};